import React = require("react")
import { cn } from "@shared/Frontend/utils/addToClassName"
import { List } from "immutable"
import { InnerHtmlWrapper } from "../../../utils/InnerHtmlWrapper"
import { CookieAccepted, CookieName, CookieState } from "./cookiebar.types.mod"

export const cookieBar_layout = function () {

  let cookiebar_single = (props: {
    title: string,
    caption_accept: string,
    accept: () => void,
    className?: string
  }) =>
    <div className={cn('cookies', props.className)}>
      <div className='cookies__inner'>
        <div className='cookies__text'>
          {props.title}
        </div>
        <button className='link' key="cookiebar-accept-key" onClick={props.accept}>
          {props.caption_accept}
        </button>
      </div>
    </div>
  
  let cookiebar = (props: {
    title: string,
    text: string,
    show_options_label: string,
    show_options: boolean,
    show_options_toggle: () => void,
    caption_accept_all: string,
    caption_decline_all: string,
    caption_apply_settings: string,
    state: List<[CookieName, CookieState]>,
    collapse_cookiebar: () => void,
    accept_all: () => void,
    decline_all: () => void,
    apply_settings: () => void,
    set_single: (cookie_name: CookieName, state: CookieAccepted) => void
  }) => <div className="cookiebar" key="cookiebar-key" role="alert">
      <div className='cookiebar__outer ls-container' key='cookiebar-key'>
        <div className='cookiebar__inner' key='cookiebar-key'>
          <div className='cookiebar__text' key='cookiebar-title-key'>
            <p className="cookiebar__title title--s">{props.title}</p>
            {/* <div dangerouslySetInnerHTML={{ __html: props.text }} /> */}
            <InnerHtmlWrapper text={props.text} />
          </div>
          <div className='cookiebar__actions' key='cookiebar-actions-key'>
            <div className="cookiebar__action" key="cookiebar-accept-key">
              <button className="cookiebar__button link" key="cookiebar-accept-key" onClick={props.accept_all}>
                {props.caption_accept_all}
              </button>
            </div>
            <div className="cookiebar__action" key="cookiebar-decline-key">
              <button className="cookiebar__button link" key="cookiebar-decline-key" onClick={props.decline_all}>
                {props.caption_decline_all}
              </button>
            </div>
          </div>
          <div className="cookiebar__form">
            <div className={`cookiebar__expand cookiebar__expand--${props.show_options ? 'open' : 'closed'} expander`}>
              <button className='expander__button' onClick={props.show_options_toggle}>
                {props.show_options_label}
                <svg className='expander__icon' aria-hidden="true" height="8" width="13">
                  {props.show_options ? <use xlinkHref="#chevron--tx" /> : <use xlinkHref="#chevron--bx" />}
                </svg>
              </button>
              {props.show_options ?
                <ul className="expander__list list">
                  <>
                  {props.state.filter(c => c[1] && c[1].label && c[1].label.trim() !== '').map(c => <li className="list__item">
                    <label className={`list__label${c[1].isAccepted == "yes" ? ' list__label--checked' : ''}`} htmlFor={c[1].htmlFor}>
                      <input
                        onChange={v => {
                          props.set_single(c[0], v.target.checked ? "yes" : "no")
                        }}
                        className="list__input"
                        type={"checkbox"}
                        aria-required={c[1].isDisabled}
                        checked={c[1].isAccepted == "yes"}
                        disabled={c[1].isDisabled}
                        id={c[1].htmlFor}
                        aria-label={c[1].label}
                      />
                      <span>{c[1].label}</span>
                    </label>
                  </li>).toArray()}
                  <button className="list__button link" key="cookiebar-applysettings-key" onClick={props.apply_settings}>
                    {props.caption_apply_settings}
                  </button>
                  </>
                </ul>
                : null}
            </div>
          </div>
          <button className="cookiebar__close" key="cookiebar-accept-key" onClick={props.collapse_cookiebar}>
            <span className="sr-text">close cookie bar</span>
          </button>
        </div>
      </div>
    </div>

  return {
    cookiebar,
    cookiebar_single
  }
}
